import {AxiosError} from 'axios';
import {GET_ACCESS_CONFIG_QUERY_KEY} from 'web-library/constants/queryKeys';
import {GET_ACCESS_CONFIG_URL} from 'web-library/constants/apiUrls';
import {
  AccessConfigDetails
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: AccessConfigDetails) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  targetRole: any;
}

export const useGetAccessConfiguration = ({onError, onSuccess, targetRole}: Input) => {
  const getAccessConfiguration = async () => {
    const res = await axiosClient.get<AccessConfigDetails>(GET_ACCESS_CONFIG_URL(targetRole));
    return res.data;
  };

  return useCustomQuery(
      [GET_ACCESS_CONFIG_QUERY_KEY, targetRole],
      getAccessConfiguration,
      {
        onSuccess,
        onError,
      },
      true,
      false
  );
};
